import { render, staticRenderFns } from "./IconCookie.vue?vue&type=template&id=6c47e84e&scoped=true&"
import script from "./IconCookie.vue?vue&type=script&lang=js&"
export * from "./IconCookie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c47e84e",
  null
  
)

export default component.exports